export default "__VITE_ASSET__c9d915a6__"